import { TenantEntity } from '../TenantEntity'

export class AssemblyPlanUld extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'AssemblyPlanUld'
  }

  // 拼装计划uuid
  get assemblyPlanUuid() {
    return this._data.assemblyPlanUuid
  }

  set assemblyPlanUuid(assemblyPlanUuid) {
    this._data.assemblyPlanUuid = assemblyPlanUuid
  }

  // 名称
  get name() {
    return this._data.name
  }

  set name(name) {
    this._data.name = name || 'A'
  }
}
